import React from "react";
import PaymentSummary from "./components/PaymentSummary";
import Payment from "./Payment";
import { ModalWrapper } from "../../../../../shared/components/ModalWrapper";
import { PaymentProps } from "./types/payment";
import { useOrderProcessing } from "./hooks/useOrderProcessing";
import Done from "../Done/Done";
import { useUser } from "src/business-types/grocery/components/UserContext";

const PayCash: React.FC<PaymentProps> = ({ cartId, backHome, backHomepay, type }) => {
  const {
    cartProducts,
    customer,
    cartLoading,
    // customerLoading,
    backToPayment,
    setBackToPayment,
    paymentSuccess,
    orderId,
    receivedAmount,
    setReceivedAmount,
    showBalance,
    setShowBalance,
    currentTime,
    roundAmount,
    handleOrderSuccess,
    buttonLoading,
  } = useOrderProcessing(cartId);
  const { userConfigration } = useUser();
  const toBoolean = (value: any) => value === true || value === "true";
  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);

  if (backToPayment) return <Payment cartId={cartId} backHomepay={backHomepay} backHome={backHome} />;
  if (paymentSuccess) return <Done orderid={orderId} onFinish={() => backHomepay("done")} customer={customer} />;

  return (
    <ModalWrapper
      title='Payment summary'
      useTheme={true}
      onClose={() => backHome("false")}
      showBackButton
      onBack={() => setBackToPayment(true)}
      className='min-w-[480px] text-center'
      width='max-w-xl w-full'
      positionClass='top-0 left-0 right-0 mt-10 h-full'
    >
      <PaymentSummary
        products={cartProducts}
        customer={customer}
        paymentMethod={type === "Cash" ? "Cash" : "Card"}
        receivedAmount={receivedAmount}
        showBalance={showBalance}
        currentTime={currentTime}
        onAmountChange={setReceivedAmount}
        onToggleBalance={() => setShowBalance((prev) => !prev)}
        roundAmount={roundAmount}
        onCancel={() => backHome("false")}
        onComplete={() => handleOrderSuccess(type === "Cash" ? "Cash" : "Card")}
        isLoading={cartLoading || !customer}
        backHome={backHome}
        buttonLoading={buttonLoading}
        deliveryFeeEnabled={deliveryFeeEnabled}
      />
    </ModalWrapper>
  );
};

export default PayCash;
